import { ContentLayout } from 'components/Layouts'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmPasswordForm } from '../components/PasswordForm/ConfirmPasswordForm'
import { GetMyMedicareCardPageContent } from '../components/GetMyMedicareCardPageContent'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { useDispatch, useSelector } from 'react-redux'
import { getErrors, getUser, setErrors, setUser } from 'redux/reducers/users'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { useAsyncInitialization } from 'hooks/useAsyncInitialization'
import { medicareApiClient } from 'clients/medicareApiClient'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { BeneficiaryModelOptions } from '@cms-max/medicare-api-sdk'

const backButtonTextKey = 'navigation.backToSettings.text'

export const GetMyMedicareCardPage = () => {
  const { t } = useTranslation('getMyMedicareCardPage')
  const [password, setPassword] = useState('')

  const formProps = {
    onSubmit: (password: string) => setPassword(password),
    href: '/account-settings'
  }

  const dispatch = useDispatch()
  const init = useCallback(async () => {
    const fullBene = await medicareApiClient.asyncGetBeneficiaryFullData([BeneficiaryModelOptions.LastCardRequestDateMs])
    if (fullBene) {
      dispatch(setUser(fullBene))

      if (fullBene?.user._errors && Object.keys(fullBene?.user._errors).length) {
        dispatch(setErrors(fullBene.user._errors))
      }
    } else {
      console.log('throwing error')
      throw new Error('Full bene response is undefined')
    }
  }, [dispatch])
  const loadingState = useAsyncInitialization(init)
  const errors = useSelector(getErrors)
  const user = useSelector(getUser)

  return (
    <>
      <BreadCrumb
        backButtonLink='/account-settings'
        backButtonText={t(backButtonTextKey)}
        navAriaLabel={t('navigation.backToSettings.navAriaLabel')}
        width='wide'
        siteActivityProps={{
          component: 'Account Settings',
          clickData: {
            linkText: t(backButtonTextKey, { lng: 'en' }),
            linkUrl: buildAbsoluteMedicareMyUrl('/account-settings')
          }
        }}
      />
      <ContentLayout
        heading={t('heading')}
        withPrintButton={false}
        width='wide'
      >
        <div className='ds-l-container'>
          {loadingState === 'loading' && (
            <MySpinner />
          )}
          {loadingState === 'finished' && (
            !password
              ? (
                <>
                  <p>{t('confirm-password.you-must-verify')}</p>
                  <ConfirmPasswordForm {...formProps} />
                </>
                )
              : (
                  <GetMyMedicareCardPageContent
                    lastCardRequestErrors={errors?.lastCardRequestDateMs}
                    lastCardRequestDateMs={user?.lastCardRequestDateMs}
                    mailingAddress={user?.mailingAddress}
                    railroadRetirementBoardBeneficiary={user?.railroadRetirementBoardBeneficiary}
                  />
                )
          )}
          {loadingState === 'error' && (
            <Alert variation='warn' className="my-u-mt--12">
              <p className="ds-c-alert__text">{t('errors.cantGetInfo')}</p>
            </Alert>
          )}
        </div>
      </ContentLayout>
    </>
  )
}
